import api from './index';
//
let exports = {};

// 获取零售商任务执行记录列表
exports.getRetailerTaskExeRecList = function (postData, callback) {
    api.post('/retailer/task/exe/rec/list/get')
    .data(postData)
    .done(callback)
    .go();
};
// 零售商任务执行记录条目分页列表
exports.getRetailerTaskSubItemList = function (postData, callback) {
    api.post('/retailer/task/exe/rec/item/list/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/taskExe.js
// module id = 404
// module chunks = 0